import axios from 'axios';
import { Balanca } from '@models/balanca.model';
import { CriaBalancaDto } from '@/../../back/src/balancas/dto/cria-balanca.dto';
import { AlteraBalancaDto } from '@/../../back/src/balancas/dto/altera-balanca.dto';

const listaBalancas = async (): Promise<Balanca[]> => {
  const res = await axios.get<Balanca[]>(`/balancas`);
  return res.data;
};

const buscaBalanca = async (balancaId: number): Promise<Balanca> => {
  const res = await axios.get<Balanca>(`/balancas/${balancaId}`);
  return res.data;
};

const criaBalanca = async (formData: CriaBalancaDto): Promise<Balanca> => {
  const res = await axios.post<Balanca>('/balancas', formData);
  return res.data;
};

const alteraBalanca = async (
  balancaId: number,
  formData: AlteraBalancaDto,
): Promise<Balanca> => {
  const res = await axios.patch<Balanca>(`/balancas/${balancaId}`, formData);
  return res.data;
};

const removeBalanca = async (balancaId: number): Promise<Balanca> => {
  const response = await axios.delete<Balanca>(`/balancas/${balancaId}`);
  return response.data;
};

const verificaConexao = async (balancaId: number): Promise<any> => {
  const res = await axios.get<any>(`/balancas/${balancaId}/verificar_conexao`);
  return res.data;
};

const valorBalanca = async (balancaId: number): Promise<any> => {
  const res = await axios.get<any>(`/balancas/${balancaId}/valor`);
  return res.data;
};
export default {
  listaBalancas,
  buscaBalanca,
  criaBalanca,
  alteraBalanca,
  removeBalanca,
  verificaConexao,
  valorBalanca,
};
